export const loginVisible = state => state.loginVisible;
export const firstLoginVisible = state => state.firstLoginVisible;
export const firstLoginInfo = state => state.firstLoginInfo;
export const userInfo = state => state.userInfo;
export const cartNum = state => state.cartNum;
export const targetRoute = state => state.targetRoute;



// WEBPACK FOOTER //
// ./src/store/getter.js